module.exports = __webpack_public_path__ + "img/Cheer Megaphone25.1994524c.jpg";